// extracted by mini-css-extract-plugin
export default {"wrapper":"TopUpByCard_wrapper__EM7nQ","text":"TopUpByCard_text__h8Fa3","input":"TopUpByCard_input__PLH9w"};